import React from "react"

const TopicText = ({ children }) => (
  <span className="bold uppercase">{children}</span>
)

export default TopicText



// WEBPACK FOOTER //
// ./src/small/TopicText.js